import { vservice } from '@niknevis/vue-modules'
import { RemoteData } from '@/modules/shared/helpers/http/remote-data'
import { Paginated } from '@/modules/shared/models/data'
import { AdminChangelogService } from '@/modules/changelog/services/admin-changelog.service'
import { ChangelogCollectionModel } from '@/modules/changelog/models/changelog-collection.model'

@vservice()
export class AdminGetChangelogUseCase {
  constructor(
    private readonly service: AdminChangelogService
  ) {
  }

  private readonly defaultRawData = {
    meta: {
      current_page: 0,
      from: 0,
      last_page: 0,
      links: [],
      path: '',
      per_page: 10,
      to: 0,
      total: 0
    },
    data: []
  }

  private remoteData = RemoteData.notAsked<Paginated<ChangelogCollectionModel[]>>()

  get isLoading() {
    return this.remoteData.isInProgress()
  }

  get getRawData() {
    return this.remoteData.fold(
      () => this.defaultRawData,
      value => value || this.defaultRawData,
      value => value,
      (error, value) => value || this.defaultRawData
    )
  }

  get getChangelogs() {
    return this.getRawData.data
  }

  get getMeta() {
    return this.getRawData.meta
  }

  execute(modelId: number, modelType: string, page: number) {
    return this.remoteData.fromPromise(
      this.service.getChangelogs(modelId, modelType, page)
    )
  }
}
